import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { useMemo } from 'react';
import { translate } from '../../Services/translation';
import Input from '../Inputs/Input';
import { FilterGroup } from './types/FilterGroup';

interface FilterSearchInputAttributes {
  filter: FilterGroup;
  onSearch?: Function;
}

const FilterSearchInput = ({
  filter,
  onSearch,
}: FilterSearchInputAttributes) => {
  const [value, setValue] = useState('');

  const matchingOptions = useMemo(
    () =>
      value != ''
        ? filter.options.filter(
            (opt) =>
              filter.selectedOptions.includes(opt.id) ||
              opt.label.toLowerCase().includes(value.toLowerCase())
          )
        : null,
    [value, filter]
  );

  useEffect(() => {
    onSearch && onSearch(filter, matchingOptions);
  }, [filter, onSearch, matchingOptions]);

  return (
    <div className="mb-2">
      <Input
        inputSize="small"
        icon="magnifier"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={translate('general.search')}
      />
    </div>
  );
};

export default FilterSearchInput;
